/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React from 'react'

import LargeKPI from './large-kpi'
import MediumContainerKPI from './medium-container-kpi'

interface Props {
  bgcNums
  mainKPI
  mainKPIData
  mediumKPIData
  setKpiName
  updateKpiFilter
}
const LargeContainerKPI = ({
  bgcNums,
  mainKPI,
  mainKPIData,
  mediumKPIData,
  setKpiName,
  updateKpiFilter,
}: Props) => {
  const mediumContainers = mediumKPIData.map((kpi: any, key) => (
    <MediumContainerKPI
      bgcNums={bgcNums[key]}
      key={key}
      mainKPI={mainKPIData[key]}
      mediumKPIData={kpi}
      setKpiName={setKpiName}
      updateKpiFilter={updateKpiFilter}
    />
  ))
  return (
    <div className='col col-md-12 align-items-stretch d-flex mt-1 '>
      <div className='bordered2 border-radius w-100 p-0 whitebg'>
        <LargeKPI key={0} kpi={mainKPI} setKpiName={setKpiName} updateKpiFilter={updateKpiFilter} />
        <div className='border-top2'>{mediumContainers}</div>
      </div>
    </div>
  )
}

export default LargeContainerKPI
